import { useState } from 'react';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { PIN_REQUEST_LIMIT, PIN_TIMEOUT_DURATION_MS } from '../constants';

export function useRateLimiting() {
	const [isRequestLimited, setIsRequestLimited] = useState(false);
	const [requestCount, setRequestCount] = useState(0);

	function applyRateLimiting() {
		const newCount = requestCount + 1;
		setRequestCount(newCount);

		if (newCount >= PIN_REQUEST_LIMIT) {
			setIsRequestLimited(true);
			message.warning(I18n.get('Too many attempts. Please try again in 5 minutes.'));

			setTimeout(() => {
				setIsRequestLimited(false);
				setRequestCount(0);
			}, PIN_TIMEOUT_DURATION_MS);
		}
	}

	return {
		isRequestLimited,
		applyRateLimiting
	};
}
